import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { GoCheck } from 'react-icons/go';
import { default as Select } from 'react-select';
import { components } from "react-select";
import moment from 'moment';

const Option = (props) => { //This is necessary to configure the options in the multi-select. The options appear without this, but they don't have the checkbox structure we want.
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

export class RegistrarDashboard extends Component {
    static displayName = RegistrarDashboard.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            browser: `${browserName}${browserVersion}`,
            NSCLFlag: false,
            permissionFlag: true,
            enrollmentOptions: [],
            activeEnrollment: [],
            confirmModal: false,
            rollClicked: false,
            rollDate: ""
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            loading: false,
            username: data.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        var dept = this.state.returnable.level
        dept = dept.substring(0, (dept.indexOf('-') - 1));
        this.recordComingHere(data);
        this.testPermission(data.level);
        this.getEnrollStatus(data.level);
        this.getRollDate(data.level);
    }

    async recordComingHere(dataIn) { 
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "1024",
            department: dataIn.level,
            userPCID: dataIn.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: dataIn.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async testPermission(dataIn) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: dataIn,
            pagepk: "1024"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getEnrollStatus(userdata) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: userdata
        }
        const response = await fetch('GetEnrollActives',{
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        //This data contains information about what should be in the list and what should be listed as active, so we can use this for both.
        this.setState({
            enrollmentOptions: data,
            activeEnrollment: data.filter(remove => remove.active == true)
            })
    }

    async getRollDate(dataIn) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: dataIn
        }
        const response = await fetch('GetRollDate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            rollDate: data.date
        })
    }

    componentDidMount() {

    }

    handleChange = (selectedOption) => {//When an option is clicked and the list is to be changed, there are a number of cases that may occur
        if (selectedOption.length > this.state.activeEnrollment.length) {//If the new list of checked items is longer than the old, one was added. 
                                                                         //This will break down a little when the users figure out how to click more than one thing at a time.
            let newItem = selectedOption.filter(remove => !this.state.activeEnrollment.includes(remove))//We can drill down the new list to only the one that isn't in the old list
            let toSend = {
                userLevel: this.state.returnable.level,
                target: newItem[0].value//This can be [0] because we're only adding one item here, until users manage to click on three at the same time.
            }
            this.sendToUpdate(toSend);//To actually save it, I put the fetch outside of this function because I didn't want this area to get crowded with that stuff
        }
        else if (selectedOption.length == 0 && this.state.activeEnrollment.length > 1) {//If no items are now selected and the previous list had more than one, the user clicked the Clear All button
            let toSend = {
                userLevel: this.state.returnable.level,
                target: "CLEAR"//We have a special code for this to make life easier in Sql Server
            }
            this.sendToUpdate(toSend);
        }
        else {//If neither of those things are true, then the user unselected a previously selected item
            let removedItem = this.state.activeEnrollment.filter(remove => !selectedOption.includes(remove))//To find it we just do the inverse of what we did in the first case
            let toSend = {
                userLevel: this.state.returnable.level,
                target: removedItem[0].value
            }
            this.sendToUpdate(toSend);
        }
        this.setState({
            activeEnrollment: selectedOption
            })
    }

    async sendToUpdate(toSend) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('UpdateRollEnrollStatus', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async rollRecords() {//This is depreciated. Used to be, the process to roll the academic records was invoked here. However, this procedure takes like an hour and rigel has no desire to wait that long
                            //before declaring it a lost cause. So, it was replaced by an option to set a date for the next time this process should execute and a job will decide whether today's the day
                            //to go and roll these looking at this value.
        this.setState({
            confirmModal: false
        })
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('RollAcademic', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            rollClicked: true
        })
        setTimeout(() => {
            this.setState({
                rollClicked: false
            })
        }, 15000)
    }

    rollToggle() {
        this.setState({
            confirmModal: !this.state.confirmModal
        })
    }

    async changeDate(e) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            newdate: e 
        }
        const response = await fetch('UpdateRollDate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            rollDate: data.date
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        //else {
            return (
                <UserContext.Consumer>
                    {contextData => (//This modal in here is effectively junk now as we don't use it anymore. It can probably be removed safely.
                        <div>
                            <Modal isOpen={this.state.confirmModal} toggle={this.rollToggle.bind(this)} size="lg">
                                <ModalHeader toggle={this.rollToggle.bind(this)}>
                                    Roll Academic and Residency Records to New Semester
                                </ModalHeader>
                                <ModalBody>
                                    You are about to perform an operation on Power Campus that rolls over all of your degree seeking students into the coming terms.  If it is currently Spring, you are about to create Summer I, Summer II, and Fall academic records for each and every degree seeking student.  If it is currently Fall, you are about to create academic records for Winter and Spring.  If it is not currently Spring or Fall, this procedure will fail to create any new data.
                                    <p />
                                    This creation of academic records for certain semesters will be suppressed in the case that the student is expected to graduate before said semester.
                                    <p />
                                    Along with the creation of these academic records, residency records will also roll over for the same set of students, into the same terms, and under the same stipulation for students expecting to graduate.
                                    <p />
                                    VERY IMPORTANT!!  This procedure will take about 1 full hour to complete.  Please be patient when running this procedure.  An email will be sent to Registrar@hood.edu when it is completed.  In that email, you will be notified of any records that were not rolled over.  If there are no excluded records, you will still get this email and it will state 'All Academic/Residency records rolled over' instead of showing a grid of items NOT rolled over.
                                    <p />
                                    Are you sure you want to continue?
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="primary" onClick={this.rollRecords.bind(this)}>Yes, roll</Button>
                                    <Button onClick={this.rollToggle.bind(this) }>Go Back</Button>
                                </ModalFooter>
                            </Modal>
                            <h2>Select Enrollment Code:</h2><p />
                            <Select //This one is the real keystone. This Select is what allows the entire process to operate smoother than a wall of checkboxes
                                isMulti //This isMulti prop specifies it to be a multiselect
                                options={this.state.enrollmentOptions} //We can enumerate the selectable options here
                                onChange={this.handleChange}
                                value={this.state.activeEnrollment}//This is the default checked we filtered out on fetch
                                components={{//Here, the extra Option class defined above the exported main comes into play to define what each option component will be structured like
                                    Option
                                }}
                                hideSelectedOptions={false}//I believe these two are defaulted to false, but it never hurts to spell it out just in case.
                                closeMenuOnSelect={false}
                                allowSelectAll={true}//This isn't actually showing up on the finished product, but it's not important enough to debug at the moment. It'll never be used anyway.
                            />
                            <p />
                            <Input type="date" name="nextExec" id="nextExec" defaultValue={this.state.rollDate} onBlur={(e) => { if (this.state.rollDate != e.target.value) { this.changeDate(e.target.value) } } } />
                            {this.state.rollClicked &&<div>The rolling process has begun. Please leave this page open in the background until the confirmation email has been received.</div> }
                        </div>
                    )}
                </UserContext.Consumer>
            );
       // }
    }
}